<template>
    <div>
        <div class="atText">Damit Sie fortfahren können, müssen Sie den Nutzungsbedingungen zustimmen.</div>
        <div class="atText">
            Bitte lesen Sie die unten angezeigten Nutzungsbedingungen aufmerksam durch und bestätigen
            Sie, dass Sie mit den Nutzungsbedingungen einverstanden sind:
        </div>
        <div class="atTerms" v-html="currentTerms.TerHtml">
        </div>
        <div class="atLink"><a :href="termLink" target="_blank">{{ currentTerms.TerName }} herunterladen</a></div>
        <div class="atText">
            Die Verfahrensbeschreibung des PEACOQ Innovation Tools
            habe ich zur Kenntnis genommen. Ich akzeptiere die beschriebenen Regelungen und
            bestätige, die mir im Rahmen der Nutzung der PEACOQ Innovation Tools zugänglichen
            und bekannt gewordenen Informationen nur zweckgebunden zu verarbeiten und Dritten
            gegenüber nicht zur Kenntnis zu geben. Dies gilt insbesondere auch für die Zugangskennung
            (Passwort) welche nur durch den Berechtigten selbst genutzt und nicht an Dritte
            weitergegeben werden darf. Besteht der Verdacht der unrechtmäßigen Kenntnisnahme
            durch Dritte oder der Verlust der Zugangskennung, so ist die Schaltzeit GmbH darüber
            umgehend zu informieren.
        </div>
        <div class="puButtons">
            <div class="puLeftButtons">
                <DxButton text="Abbrechen" @click="cancelTerms" type="danger" />
            </div>
            <div class="puRightButtons">
                <DxButton text="Ich akzeptiere die Verfahrens- und Nutzungsregelung" type="success" @click="acceptTerms" />
            </div>
        </div>
    </div>
</template>

<script>
    import DxButton from 'devextreme-vue/button'
    import $ from 'jquery';

    export default {
        name: 'AcceptTerms',
        components: {
            DxButton
        },
        data() {
            return {
            }
        },
        computed: {
            currentTerms() {
                return this.$store.state.termStore.currentTerms
            },
            termLink() {
                return this.$store.state.termStore.termLink
            },
        },
        mounted: function () {
            this.$store.dispatch("getCurrentTerms", { tetId: 1 })
        },
        methods: {
            cancelTerms() {
                window.LoadingPanel.Show()
                $("form").attr("action", "../Login.aspx").submit();
            },
            acceptTerms() {
                this.$store.dispatch("acceptCurrentTerms", {}).then(() => {
                    window.LoadingPanel.Show()
                    setTimeout(() => {
                        $("form").attr("action", "../Start.aspx").submit();
                    }, 750)
                })
            }
        }
    }

</script>
<style scoped>

    .puButtons {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }


    .puRightButtons {
        display: flex;
        gap: 10px;
    }

    .atTerms {
        width: 100%;
        border: 1px solid silver;
        padding: 2px;
        height: 380px;
        overflow-y: auto;
        margin: 20px 0 20px 0;
    }

    .atText {
        padding-bottom: 5px;
    }

    .puButtons {
        padding-top: 20px;
    }

    .atLink {
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
        padding-bottom: 20px;
    }
</style>
